import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';
import {betterAuthErrorSchema} from './better-auth-response.schemas';

const changePasswordResponseSchema = z.object({
  data: z.unknown().nullish(),
  error: betterAuthErrorSchema.nullish(),
});

export type BetterAuthChangePasswordResponse = z.output<typeof changePasswordResponseSchema>;

export class BetterAuthChangePasswordResponseValidator
  implements Validator<BetterAuthChangePasswordResponse>
{
  readonly standardSchema = changePasswordResponseSchema;

  validate(value: unknown): Result<BetterAuthChangePasswordResponse, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Unexpected change-password response shape.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
